<template>
  <ApolloQuery :query="PRODUCT_QUERY" :variables="variables">
    <template v-slot="{ result: { loading, error, data } }">
      <TalpaLoaderWrapper :transparent="true" v-if="loading" />
      <ErrorAtom v-else-if="error" :error="error" />
      <template v-else-if="data">
        <ProductDetailsMolecule :product="data.product" />
      </template>
    </template>
  </ApolloQuery>
</template>

<script>
import { TalpaLoaderWrapper, ErrorAtom } from '@common/components'

import ProductDetailsMolecule from '../Molecules/ProductDetailsMolecule'

import PRODUCT_QUERY from '#/graphql/marketplace/productQuery.gql'

export default {
  props: {
    productId: {
      type: String,
      required: true,
    },
  },
  components: {
    TalpaLoaderWrapper,
    ErrorAtom,
    ProductDetailsMolecule,
  },
  data() {
    return {
      PRODUCT_QUERY,
    }
  },
  computed: {
    variables() {
      return {
        where: {
          id: this.productId,
        },
      }
    },
  },
}
</script>
